<template>
    <div>
        <van-nav-bar class="nav-bar" title="发布资源" left-text="返回" left-arrow @click-left="$router.push({path:'/'})" />
        
        <div>
            <van-form ref="form" :rules="rules" >
                <van-field v-model="resource.resourceName" name="资源名称" label="资源名称" :rules="rules.resourceName" placeholder="请输入资源名称"/>
                <van-field readonly clickable name="picker" right-icon="arrow" :value="resource.cpuCore" label="CPU核心数" placeholder="请选择CPU核心数"
                    :rules="rules.cpuCore"
                    @click="resource.showPickerCpu = true"
                />
                <van-popup v-model="resource.showPickerCpu" position="bottom">
                    <van-picker show-toolbar :columns="resource.columnCpu"
                        @confirm="onConfirmCpu"
                        @cancel="resource.showPickerCpu = false"
                    />
                </van-popup>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.memoryCapacity"
                    label="内存容量"
                    placeholder="请选择内存容量"
                    :rules="rules.memoryCapacity"
                    @click="resource.showPickerMemoryCapacity = true"
                />
                <van-popup v-model="resource.showPickerMemoryCapacity" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="resource.columnMemoryCapacity"
                        @confirm="onConfirmMemoryCapacity"
                        @cancel="resource.showPickerMemoryCapacity = false"
                    />
                </van-popup>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.hardDisk"
                    label="硬盘容量"
                    placeholder="请选择硬盘容量"
                    :rules="rules.hardDisk"
                    @click="resource.showPickerHardDisk = true"
                />
                <van-popup v-model="resource.showPickerHardDisk" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="resource.columnHardDisk"
                        @confirm="onConfirmHardDisk"
                        @cancel="resource.showPickerHardDisk = false"
                    />
                </van-popup>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.model"
                    label="型号"
                    placeholder="请选择型号"
                    :rules="rules.model"
                    @click="resource.showPickerModel = true"
                />
                <van-popup v-model="resource.showPickerModel"   position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="resource.columnModel"
                        @confirm="onConfirmModel"
                        @cancel="resource.showPickerModel = false"
                    />
                </van-popup>
                <van-field v-model="resource.cardsNum" name="卡数" label="卡数" placeholder="请输入卡数" :rules="rules.cardsNum"/>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.networking"
                    label="组网"
                    placeholder="请选择组网"
                    :rules="rules.networking"
                    @click="resource.showPickerNetworking = true"
                />
                <van-popup v-model="resource.showPickerNetworking" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="resource.columnNetworking"
                        @confirm="onConfirmNetworking"
                        @cancel="resource.showPickerNetworking = false"
                    />
                </van-popup>
                <van-field v-model="resource.totalNum" name="台数" label="台数" placeholder="请输入台数" :rules="rules.totalNum"/>
                
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.address"
                    label="地点"
                    placeholder="请选择地点"
                    :rules="rules.address"
                    @click="resource.showPickerAddress = true"
                />
                <van-popup v-model="resource.showPickerAddress" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="resource.columnAddress"
                        @confirm="onConfirmAddress"
                        @cancel="resource.showPickerAddress = false"
                    />
                </van-popup>
                <van-field name="radio" label="资源状态" >
                    <template #input>
                        <van-radio-group v-model="resource.rentOn" direction="horizontal" >
                            <van-radio name="1" >随时可租</van-radio>
                            <van-radio name="2" >指定日期可租</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                    v-show="resource.rentOn == '2'"
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="resource.rentDate"
                    label="可租日期"
                    placeholder="请选择可租日期"
                    :rules="rules.rentDate"
                    @click="resource.showPickerDate = true"
                />
                <van-popup v-model="resource.showPickerDate" position="bottom">
                    <van-datetime-picker
                        show-toolbar
                        type="date"
                        title="选择年月日"
                        :min-date="resource.minDate" 
                        :max-date="resource.maxDate"
                        :formatter="formatter"
                        @confirm="onConfirmDate"
                        @cancel="resource.showPickerDate = false"
                    />
                </van-popup>
                <van-field v-model="resource.monthRent" name="月租金额" label="月租金额" placeholder="请输入月租金额"/>
                <van-field v-model="resource.yearRent" name="年租金额" label="年租金额" placeholder="请输入年租金额"/>
                <van-field v-model="resource.payType" name="付款方式" label="付款方式" placeholder="请输入付款方式(可选填)"/>
                <van-field
                    v-model="resource.resourceDesc"
                    rows="2"
                    autosize
                    label="资源描述"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入资源描述"
                    show-word-limit
                    :rules="rules.teachingContent"
                />
                <van-field
                    v-model="resource.remark"
                    rows="2"
                    autosize
                    label="备注"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入备注"
                    show-word-limit
                    :rules="rules.remark"
                />
                
                <van-button class="submit-button" round block type="info" native-type="submit" @click="onSubmit()">提 交</van-button>
            </van-form>
            <!-- <div class="submit-button">
                
            </div> -->
        </div>
    </div>
</template>

<script>
import {
    releaseResource
} from '@/api/index';
import { Toast } from 'vant';
export default {
    data() {
        return {
            resource:{
                resourceName:"", //资源名称
                cpuCore:"", //CPU核心数
                columnCpu:['0','2','4','8','16','28','32','48'],
                showPickerCpu:false,
                memoryCapacity:"" , //内存容量
                columnMemoryCapacity:['0','2G','4G','8G','16G','32G','64G'],
                showPickerMemoryCapacity:false,
                
                hardDisk:"", //硬盘容量
                columnHardDisk:['0','480GB','500GB','960GB','1024GB','2048GB','4096GB','6000GB'],

                showPickerHardDisk:false,
                model:"", //型号
                columnModel:['H800','H200','H20','H100','A800','A100','4090'],
                showPickerModel:false,
                cardsNum:"", //卡数
                networking:"",//组网
                columnNetworking:['IB','Roce'],
                showPickerNetworking:false,

                totalNum:"", //台数
                address:"", //地点
                columnAddress:['北京','新疆','青海','上海','广州','温州','郑州','宁夏','廊坊','连云港','金华','厦门','福州'],
                showPickerAddress:false,

                rentOn:"1", //资源状态
                rentDate:"",//指定日期
                minDate:new Date(2023, 0, 1),
                maxDate: new Date(2030, 12, 31),
                showPickerDate:false,
                monthRent:"", //月租金额
                yearRent:"", //年租金额
                payType:"", //付款方式
                resourceDesc:"", //资源描述
                remark:"", //备注
                
                
                
                
            },
            rules:{
                resourceName:[{ required: true, message: '请输入资源名称' }],
                cpuCore:[{ required: true, message: '请选择CPU核心数' }],
                memoryCapacity:[{ required: true, message: '请选择内存容量' }],
                hardDisk:[{ required: true, message: '请选择硬盘容量' }],
                model:[{ required: true, message: '请选择型号' }],
                cardsNum:[{ required: true, message: '请输入卡数' }],
                networking:[{ required: true, message: '请选择组网' }],
                totalNum:[{ required: true, message: '请输入台数' }],
                address:[{ required: true, message: '请选择地点' }],
                rentOn:[{ required: true, message: '请选择资源状态' }],
                monthRent:[{ required: true, message: '请输入月租金额' }],
                yearRent:[{ required: true, message: '请输入年租金额' }],
                // payType:[{ required: true, message: '请输入付款方式' }],
                resourceDesc:[{ required: true, message: '请输入资源描述' }],
                // remark:[{ required: true, message: '请输入备注' }],
            },
        };
    },

    mounted() {
        
    },

    methods: {
        //选择CPU核心数
        onConfirmCpu(item){
            this.resource.cpuCore = parseInt(item)
            this.resource.showPickerCpu = false;
        },
        extractNumber(str){
            const match = str.match(/\d+/);
            return match ? parseInt(match[0], 10) : null;
        },
        //选择内存容量
        onConfirmMemoryCapacity(item){
            this.resource.memoryCapacity = this.extractNumber(item)
            this.resource.showPickerMemoryCapacity = false;
        },
        //选择硬盘容量
        onConfirmHardDisk(item){
            this.resource.hardDisk = this.extractNumber(item);
            this.resource.showPickerHardDisk = false;
        },
        //选择型号
        onConfirmModel(item){
            this.resource.model = item;
            this.resource.showPickerModel = false;
        },
        //选择组网
        onConfirmNetworking(item){
            this.resource.networking = item;
            this.resource.showPickerNetworking = false;
        },
        //选择地点
        onConfirmAddress(item){
            this.resource.address = item;
            this.resource.showPickerAddress = false;
        },
        //选择可租日期
        // 日期组件自定义格式
        formatter (type, value) {
            if (type === 'year') {
                this.value1 = value   // 可以拿到当前点击的数值
                return `${value}年`
            } else if (type === 'month') {
                this.value2 = value
                return `${value}月`
            }
            this.value3 = value
            return `${value}日`
        },
        onConfirmDate(){
            this.resource.rentDate = `${this.value1}-${this.value2}-${this.value3}`;
            this.resource.showPickerDate = false;
        },
        
        //提交
        onSubmit(){
            let data = {
                resourceName:this.resource.resourceName,//资源名称
                resourceDesc:this.resource.resourceDesc,//资源描述
                cpuCore:this.resource.cpuCore,//CPU核心数
                memoryCapacity:this.resource.memoryCapacity,//内存容量
                hardDisk:this.resource.hardDisk,//硬盘容量
                address:this.resource.address,//地点
                model:this.resource.model,//型号
                cardsNum:this.resource.cardsNum,//卡数
                networking:this.resource.networking,//组网
                totalNum:this.resource.totalNum,//台数
                // rentableNum:this.resource.resRentableNum,//可租台数
                
                rentOn:this.resource.rentOn,//资源状态
                rentDate:this.resource.rentDate,//可租日期
                monthRent:this.resource.monthRent,//月租金额
                yearRent:this.resource.yearRent,//年租金额
                // source:this.resource.resSource,//来源
                payType:this.resource.payType,//可接受付款方式
                remark:this.resource.remark,//备注
            }
            console.log(data);
            releaseResource(data).then(res=>{
                if(res.data && res.success){
                    Toast.success('资源发布成功');
                    //跳转回首页
                    setTimeout(() => {
                        this.$router.push({path:'/'});
                    }, 1000);
                }else {
                    Toast.fail(res.message);
                }
            })
        },
    },
};
</script>
<style scoped>
.submit-button{
    width:90%;
    margin:20px auto;
}
</style>